"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainSchema = exports.DomainProvisioningStage = exports.getDomainTargetByIp = exports.DomainTarget = exports.DomainStatus = exports.CONST_CLOUFLARE_STATUS_READY = void 0;
const mongoose_1 = require("mongoose");
exports.CONST_CLOUFLARE_STATUS_READY = "active";
var DomainStatus;
(function (DomainStatus) {
    DomainStatus["PENDING"] = "pending";
    DomainStatus["READY"] = "ready";
    DomainStatus["READY_AND_NOTIFIED"] = "ready-and-notified";
    DomainStatus["WITHOUT_CLOUDFLARE"] = "without-cloudflare";
})(DomainStatus = exports.DomainStatus || (exports.DomainStatus = {}));
var DomainTarget;
(function (DomainTarget) {
    DomainTarget["KEITARO"] = "keitaro";
    DomainTarget["HOSTING"] = "hosting";
    DomainTarget["WEBVIEW"] = "webview";
    DomainTarget["OTHER"] = "other";
    DomainTarget["MAIN"] = "main";
    DomainTarget["UNKNOWN"] = "unknown";
})(DomainTarget = exports.DomainTarget || (exports.DomainTarget = {}));
let getDomainTargetByIp = (ip) => {
    switch (ip) {
        case "37.27.0.169":
            return DomainTarget.MAIN;
        case "none":
            return DomainTarget.UNKNOWN;
        default: return DomainTarget.OTHER;
    }
};
exports.getDomainTargetByIp = getDomainTargetByIp;
var DomainProvisioningStage;
(function (DomainProvisioningStage) {
    DomainProvisioningStage["NAMECHEAP_VISIBLE"] = "namecheap-visible";
    DomainProvisioningStage["CLOUDFLARE_ZONE_CREATED"] = "cloudflare-zone-created";
    DomainProvisioningStage["REGISTRAR_NS_SYNCED"] = "registrar-ns-synced";
    DomainProvisioningStage["PUBLIC_NS_PROPAGATED"] = "public-ns-propagated";
    DomainProvisioningStage["CLOUDFLARE_ACTIVE"] = "cloudflare-active";
    DomainProvisioningStage["DNS_RECORD_CONFIGURED"] = "dns-record-configured";
    DomainProvisioningStage["DNS_PROPAGATED"] = "dns-propagated";
    DomainProvisioningStage["HELPER_BOOTSTRAPPED"] = "helper-bootstrapped";
    DomainProvisioningStage["TLS_READY"] = "tls-ready";
    DomainProvisioningStage["DNS_READY"] = "dns-ready";
    DomainProvisioningStage["ORIGIN_READY"] = "origin-ready";
})(DomainProvisioningStage = exports.DomainProvisioningStage || (exports.DomainProvisioningStage = {}));
exports.DomainSchema = new mongoose_1.Schema({
    id: String,
    namecheapId: String,
    registrar: String,
    registrarDomainId: String,
    name: String,
    caption: String,
    status: String,
    isUpdating: Boolean,
    cloudflareStatus: String,
    paused: Boolean,
    type: String,
    nameServers: [String],
    originalNameServers: [String],
    originalRegistrar: String,
    originalDNSHost: String,
    createdAt: Number,
    expiresAt: Number,
    ip: String,
    aRecords: { type: [{ host: String, value: String, proxied: Boolean }], default: [] },
    subdomain: String,
    txtRecords: { type: [mongoose_1.Schema.Types.Mixed], default: [] },
    mxRecords: { type: [{ host: String, value: String, priority: Number }], default: [] },
    mxRecord: String,
    mxPriority: { type: Number, default: 10 },
    aaaaRecords: { type: [{ host: String, value: String }], default: [] },
    target: String,
    assignedTo: [Number],
    archived: Boolean,
    title: String,
    note: String,
    proxied: Boolean,
    appid: Number,
    serverId: String,
    expirationMessageSent: { type: Boolean, default: false },
    cloudflareNsSyncLastAttemptAt: Number,
    cloudflareNsSyncLastSuccessAt: Number,
    cloudflareNsSyncAlertSentAt: Number,
    provisioningStage: String,
    provisioningError: String,
    provisioningStageUpdatedAt: Number,
    functionalStatus: String,
    functionalCheckedAt: Number,
    functionalError: String,
    lastHealthyAt: Number,
    hostingArchiveUploadedAt: Number
});
